import { ArrowLeft, Zap, CalendarClock, Calendar, Clock } from "lucide-react"
import { useWizard } from "./WizardContext"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

const timelineOptions = [
  { value: "Immediately", label: "As soon as possible", desc: "Emergency or urgent need", icon: Zap, accent: true },
  { value: "2-4 weeks", label: "Within 2-4 weeks", desc: "Planning ahead", icon: CalendarClock, accent: false },
  { value: "5+ weeks", label: "5+ weeks out", desc: "No rush, flexible timing", icon: Calendar, accent: false },
]

export default function TimelineStep() {
  const { state, setTimeline, nextStep, prevStep } = useWizard()

  const handleSelect = (value: string) => {
    setTimeline(value)
    nextStep()
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-foreground tracking-tight">
          When do you need this done?
        </h2>
        <p className="text-muted-foreground mt-1">
          Your timeline helps us plan crew availability and materials ordering.
        </p>
      </div>

      <div className="grid gap-3">
        {timelineOptions.map((option) => {
          const isSelected = state.timeline === option.value
          const Icon = option.icon
          return (
            <button
              key={option.value}
              onClick={() => handleSelect(option.value)}
              className={cn(
                "flex items-center gap-4 p-5 border-2 rounded-xl text-left transition-all duration-200 hover:border-primary/50 group",
                isSelected
                  ? "border-primary bg-primary/5 ring-2 ring-primary/20"
                  : "border-muted",
              )}
            >
              <div
                className={cn(
                  "w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors",
                  isSelected
                    ? "bg-primary text-white"
                    : option.accent
                      ? "bg-orange-100 text-orange-600 group-hover:bg-orange-200"
                      : "bg-muted text-muted-foreground group-hover:text-foreground",
                )}
              >
                <Icon className="w-6 h-6" />
              </div>
              <div>
                <div className="font-bold text-foreground">{option.label}</div>
                <div className="text-sm text-muted-foreground mt-0.5">{option.desc}</div>
              </div>
            </button>
          )
        })}
      </div>

      <Button variant="outline" onClick={prevStep} className="h-12 px-6 rounded-xl font-semibold">
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back
      </Button>
    </div>
  )
}
